import axios, { AxiosResponse } from 'axios';

import { IApiListParams, ILeagueApiListResponse } from '@/types';

export const loadLeagues = (params: IApiListParams): Promise<AxiosResponse<ILeagueApiListResponse>> => {
    return axios.get('/api/league/list', { params });
};

export const addFavoriteLeague = (clId: number) => {
    return axios.post('/api/favoriteLeague/create', { rows: [{ clId }] });
};

export const removeFavoriteLeague = (clId: number) => {
    return axios.post('/api/favoriteLeague/delete', { rows: [{ id: clId }] });
};
